// src/util/bgClass.ts
export type BackgroundOption = 'none' | 'tint' | 'white' | 'gradDown' | 'gradUp' | 'gradDownStrong' | 'gradUpStrong'

/** Map admin background select → Tailwind classes */
export function bgClass(value?: string | null): string {
  switch (value as BackgroundOption) {
    case 'tint':
      return 'bg-minigreen-bg-light'
    case 'white':
      return 'bg-white dark:bg-mini-black'
    case 'gradDown':
      return 'bg-gradient-to-b from-minigreen-bg-light to-white dark:bg-gradient-to-b dark:from-[#0A2F1F] dark:to-[#0a0a0a]'
    case 'gradUp':
      return 'bg-gradient-to-b from-white to-minigreen-bg-light dark:bg-gradient-to-b dark:from-[#0a0a0a] dark:to-[#0A2F1F]'
    case 'gradDownStrong':
      return 'bg-gradient-to-b from-minigreen-1 to-white dark:bg-gradient-to-b dark:from-[#0A2F1F] dark:to-[#0a0a0a]'
    case 'gradUpStrong':
      return 'bg-gradient-to-b from-white to-minigreen-1 dark:bg-gradient-to-b dark:from-[#0a0a0a] dark:to-[#0A2F1F]'
    case 'none':
    default:
      return 'bg-transparent'
  }
}
